import i18n from "i18next";
import { EnTranslation } from "locales/english";
import { EsTranslation } from "locales/spanish";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: EnTranslation,
  },
  es: {
    translation: EsTranslation,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
  });

export default i18n;
